export const oneSchemaEndpoints = {
  getTemplateJson: { method: 'get', path: '/json-template' },
  generateOneSchemaToken: { method: 'post', path: '/generate-token' },
  oneSchemaValidationWebhook: { method: 'post', path: '/webhooks/validations' },
  createOneSchemaTemplate: { method: 'post', path: '/create-template' },
} as const
